class AdpSelectDropdownController {
  constructor() {
      this.opened = false;
  }
  toggleSelectDropdown() {
      this.opened = !this.opened;
  }
}

export default AdpSelectDropdownController;



// WEBPACK FOOTER //
// ./src/app/components/adpSelectDropdown/adpSelectDropdown.controller.js